<template>
  <section id="intervieList" class="interview-list" data-scroll-section>
    <div class="l-container">
      <CSectionTitle textColor="white">
        <template v-slot:titleEn>
          {{ type === 'top' ? 'SPECIAL INTERVIEW' : 'OTHER INTERVIEW' }}
        </template>
        <template v-slot:titleJa>
          {{
            type === 'top' ? 'スペシャルインタビュー' : 'その他のインタビュー'
          }}
        </template>
        <template v-slot:bg> </template>
      </CSectionTitle>
    </div>
    <div v-if="type === 'top'" class="interview-list__lead">
      <p>
        髪のプロフェッショナルであるOCEAN
        TOKYOがつくる最強のヘアワックス「JET」。<br />
        今回のキービジュアルでは業界をリードするプロフェッショナルとコラボし、<br
          class="pc"
        />

        勢いある彼らを「JET」で、さらに加速させるようなビジュアルイメージをつくりました。<br />
        <br />
        <br />
        TRICO史上、最強に豪華なメンバーは、<span class="bold"
          >動画クリエイターの水溜りボンド。</span
        ><br class="pc" /><span class="bold"
          >eスポーツプレイヤーから、ときど</span
        >。 そして<span class="bold">OCEAN TOKYO 三科光平</span>。<br />
        日々のハードワークを生き抜く彼らの髪に「JET」がハードな立体感を演出。<br />
        <br />
        <br />
        キャッチコピーに込められた「最強になれよ。」というOCEANからのメッセージ。<br />
        それぞれのプロフェッショナルが考える<br class="sp" />"最強"とは何か？
        <br />OCEAN
        TRICO公式ウェブサイト限定のスペシャルインタビューをお楽しみください！
      </p>
    </div>
    <div class="interview-list__container">
      <component
        v-for="item in interviewList"
        :key="item.name"
        :is="item.component"
      />
    </div>
  </section>
</template>

<script>
import InterviewItemMizutamari from '@/components/InterviewItemMizutamari.vue'
import InterviewItemTokido from '@/components/InterviewItemTokido.vue'
import InterviewItemMishina from '@/components/InterviewItemMishina.vue'
import CSectionTitle from '@/components/C-SectionTitle.vue'

export default {
  props: {
    type: {
      type: String,
      default: 'top'
    },
    list: {
      type: Array,
      default: () => ['mizutamari', 'tokido', 'mishina']
    }
  },

  components: {
    InterviewItemMizutamari,
    InterviewItemTokido,
    InterviewItemMishina,
    CSectionTitle
  },

  computed: {
    interviewList() {
      return this.list.map((item) => {
        let comp = null
        switch (item) {
          case 'mizutamari':
            comp = 'InterviewItemMizutamari'
            break
          case 'tokido':
            comp = 'InterviewItemTokido'
            break
          case 'mishina':
            comp = 'InterviewItemMishina'
            break
        }

        return { name: item, component: comp }
      })
    }
  },

  methods: {
    onInterviewClick() {
      this.$router.push('/interview/aaaa')
    }
  }
}
</script>

<style lang="scss" scoped>
.interview-list {
  padding: 12rem 0 0;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 8rem 0 0;
  }

  &__container {
    padding: 8rem 0 0;
    @media screen and (max-width: $breakpoint-mobile) {
      padding: 4rem 0 10rem;
    }
  }

  &__lead {
    width: 100%;
    margin: 0 auto;
    padding: 0 1.5rem;
    display: flex;
    justify-content: center;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 100%;
      padding: 4rem 2.5rem 0;
    }
    p {
      color: #fff;
      font-size: 2.2rem;
      transform: skew(0deg, -6deg);
      text-align: left;
      font-weight: 800;
      padding: 0rem 0rem 8rem;
      line-height: 1.45;
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 1.5rem;
        padding: 0;
        line-height: 1.5;
      }
    }
  }
}
</style>
